import {
    createApi,
    fetchBaseQuery,
    type BaseQueryFn,
    type FetchArgs,
    type FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';

export type ApiError = {
    status: number | string;
    data?: unknown;
    error?: string;
};

const rawBaseQuery = fetchBaseQuery({
    baseUrl: window.location.origin,
    prepareHeaders,
});

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, ApiError, {}, FetchBaseQueryMeta> = async (
    args,
    api,
    extraOptions
) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error !== undefined) {
        return {
            error: {
                status: result.error.status,
                data: 'data' in result.error ? result.error.data : undefined,
                error: 'error' in result.error ? result.error.error : undefined,
            },
            meta: result.meta,
        };
    }

    return result;
};

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery,
    tagTypes: ['Asset', 'Account', 'RentalCompany', 'Contract'],
    endpoints: () => ({}),
});
